import React from 'react';
import { Button } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';

const DriverLocationMap = ({ driverLocation, pickupLocation, dropLocation, driverName, vehicleType }) => {
  if (!driverLocation || !driverLocation.lat || !driverLocation.lng) {
    return (
      <div className="text-center py-4">
        <div className="text-muted">
          <FaMapMarkerAlt className="fa-2x mb-2" />
          <p>Live location tracking is not available right now.</p>
          <small>The driver location will appear here when available.</small>
        </div>
      </div>
    );
  }

  const openGoogleMaps = () => {
    const { lat, lng } = driverLocation;
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}&ll=${lat},${lng}&z=15`;
    window.open(googleMapsUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="text-center py-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '12px', color: 'white' }}>
      <FaMapMarkerAlt className="fa-3x mb-3" />
      <h5 className="mb-2">Driver Location Available</h5>
      <p className="mb-3">
        <strong>{driverName || 'Driver'}</strong> • {vehicleType || 'Vehicle'}<br />
        <small>Last updated: {new Date(driverLocation.lastUpdated).toLocaleTimeString()}</small>
      </p>
      <Button
        variant="light"
        size="lg"
        onClick={openGoogleMaps}
        className="px-4 py-2"
        style={{ fontWeight: '600', borderRadius: '25px' }}
      >
        <FaMapMarkerAlt className="me-2" />
        View on Google Maps
      </Button>
    </div>
  );
};

export default DriverLocationMap;
